// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PictureOutlinedSvg from "@fishx/icons-svg/es/asn/PictureOutlined";
import FishxIcon from '../components/FishxIcon';

var PictureOutlined = function PictureOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PictureOutlinedSvg
  }));
};

PictureOutlined.displayName = 'PictureOutlined';
export default React.forwardRef(PictureOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PictureOutlined.js
// module id = 3783
// module chunks = 0